import BSQuinoaProduct from 'models/BSQuinoaProduct'

export const packagingInitialState = {
  category: BSQuinoaProduct.category,
  subCategory: BSQuinoaProduct.subCategory,
  Size: BSQuinoaProduct.Size,
}
